export const SET_NOTIFICATION_DATA = "SET_NOTIFICATION_DATA";
export const SHOW_LESS_NOTIFICATION_READ = "SHOW_MORE_NOTIFICATION";
export const SHOW_LESS_NOTIFICATION = "SHOW_LESS_NOTIFICATION";

const initialState = {
  showClassNotification: false,
  notificationDataUnread: [],
  limitValue: 20,
  showLess: false,
  totalCount: 0,
  showMore: true,

  notificationDataRead: [],
  totalReadCount: 0,
  limitRead: 20,
  showMoreRead: true,
  showLessRead: false,
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_NOTIFICATION_DATA: {
      return { ...state, ...action.payload };
    }
    case SHOW_LESS_NOTIFICATION_READ: {
      return {
        ...state,
        showLessRead: false,
        showMoreRead: true,
        limitRead: 20,
      };
    }
    case SHOW_LESS_NOTIFICATION: {
      return { ...state, showLess: false, showMore: true, limitValue: 20 };
    }
    default:
      return state;
  }
};
